






































































































































































import StatementAccountInfo from './StatementAccountInfo.vue';
import FinancialStatementTips from './FinancialSettlementTips.vue'
import CommonIconBtn from "@/components/Common/CommonIconBtn.vue";
import InsuranceCommissionList from "./list/InsuranceCommissionList.vue";
import OfferItemCommissionList from "./list/OfferItemCommissionList.vue";
import ServiceFeeCommissionList from "./list/ServiceFeeCommissionList.vue";
import AccommodationCommissionList from "./list/AccommodationCommissionList.vue";
import SettlingFileListDialog from './dialog/SettlingFileListDialog.vue';
import SubmissionConfirmDialog from './dialog/SubmissionConfirmDialog.vue';
import SettlingUploadStatementDialog from './dialog/SettlingUploadStatementDialog.vue';
import {
  inSettlementApi,
  submitSettlementApi,
  previewSettlementApi,
  totalInSettlementCommissionApi,
} from "@/api/index";
import { Component, Vue } from "vue-property-decorator";
import { getDateTimeFormat, getFilenameFromContentDisposition } from "@/utils/function_utils";

@Component({
  name: "settlingComponent",
  components: {
    CommonIconBtn,
    StatementAccountInfo,
    FinancialStatementTips,
    InsuranceCommissionList,
    OfferItemCommissionList,
    ServiceFeeCommissionList,
    AccommodationCommissionList,
    SettlingFileListDialog,
    SubmissionConfirmDialog,
    SettlingUploadStatementDialog,
  },
})
export default class extends Vue {
  public aUrl = ''
  public loading = false;
  public dialogConfirmVisible = false; // 确认结算完成弹窗
  public dialogFileListVisible = false;
  public dialogUploadFileVisible = false;
  public uploadESignInfo = {
    signFlag: true,
  };
  public submitSettlementDateTime: any = ''; // 确认结算完成时间
  public previewFiles: any = [];
  public datas: any = [];
  public showNoData = false;
  public totalCommission: any = [];

  public popRollBackReason(item: any) {
    return this.$confirm(item.rollBackReason as string, '', {
      confirmButtonText: this.$t('common.confirm') as string,
      showCancelButton: false,
      type: 'warning',
    })
  }

  public formatDate(date: any) {
    if (date) {
      const ym = date.split(" ")[0];
      const ymArr = ym.split("-");
      return `${ymArr[0]}${ymArr[1]}`;
    }
    return "";
  }

  public handlePreviewFile(previewFiles: any) {
    this.previewFiles = previewFiles;
    this.dialogFileListVisible = true;
  }

  public async totalInSettlementCommission() {
    try {
      const { data } = await totalInSettlementCommissionApi();
      this.totalCommission = data.data;
    } catch (err) {
      //
    }
  }

  // 结算中佣金
  public async getDatas() {
    try {
      const { data } = await inSettlementApi();
      this.datas = data.data;
      if (!data.data.length) {
        this.showNoData = true;
        return;
      }
      this.totalInSettlementCommission();
    } catch (err) {
      //
    }
  }

  public submitSettlementSuccess() {
    this.dialogUploadFileVisible = false;
    this.getDatas();
    const dateTime = new Date().getTime();
    this.submitSettlementDateTime = dateTime;
    this.dialogConfirmVisible = true;
  }
  // public updateFilesSuccess() {
  //   this.dialogUploadFileVisible = false;
  //   this.$confirm(`<div style="display: flex;justify-content: center;align-items: center;font-size: 20px;">${this.$t('common.submitSuccess') as string}</div>`, this.$t('common.tip') as string, {
  //     confirmButtonText: this.$t('login.confirm') as string,
  //     dangerouslyUseHTMLString: true,
  //     type: 'success',
  //     showClose: false,
  //     showCancelButton: false,
  //     center: true,
  //     closeOnClickModal: false,
  //     closeOnPressEscape: false,
  //     customClass: 'settling-confirm-box',
  //     confirmButtonClass: 'confirm-btn'
  //   }).then(() => {
  //     this.getDatas();
  //   })
  // }

  public uploadFile(item: any) {
    const params = this.getSubmitFormData(item);
    this.uploadESignInfo = Object.assign({}, this.uploadESignInfo, params);
    this.dialogUploadFileVisible = true;
  }

  public async downloadFile(item: any) {
    this.loading = true;
    const params: any = this.getSubmitFormData(item);
    params.signFlag = false;
    try {
      const res = await previewSettlementApi(params);
      if (res) {
        // const blob = new Blob([res.data], { type: "application/pdf" });
        // const elink = document.createElement("a");
        // elink.download = getFilenameFromContentDisposition(res.headers['content-disposition']) as string;
        // elink.style.display = "none";
        // elink.href = URL.createObjectURL(blob);
        // document.body.appendChild(elink);
        // elink.click();
        // URL.revokeObjectURL(elink.href); // 释放URL 对象
        // document.body.removeChild(elink);
        // this.loading = false;
        // this.$message.success(this.$t('message.downloadSuccess') as string);
        const dateTime = (new Date()).getTime();
        const blob = new Blob([res.data]);
        const elink = document.createElement("a");
        elink.download = getDateTimeFormat(dateTime);
        elink.style.display = "none";
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
        this.loading = false;
        this.$message.success(this.$t('message.downloadSuccess') as string);
      }
    } catch (err) {
      this.loading = false;
    }
  }

  public getSubmitFormData(item: any) {
    const offerItem = item.studentOfferItemCommissionDtoList.map((v: any) => {
      return {
        fkPayablePlanId: v.id,
        statusSettlement: v.statusSettlement,
      }
    });
    // 暂时只需要留学申请部分
    // const insurance = item.studentInsuranceCommissionDtoList.map((v: any) => {
    //   return {
    //     fkPayablePlanId: v.id,
    //     statusSettlement: v.statusSettlement,
    //   }
    // });
    // const serviceFee = item.studentServiceFeeCommissionDtoList.map((v: any) => {
    //   return {
    //     fkPayablePlanId: v.id,
    //     statusSettlement: v.statusSettlement,
    //   }
    // });
    // const accommodation = item.studentAccommodationCommissionDtoList.map((v: any) => {
    //   return {
    //     fkPayablePlanId: v.id,
    //     statusSettlement: v.statusSettlement,
    //   }
    // });
    return {
      flag: false,
      optGuid: item.optGuid,
      fkAgentContractAccountId: item.fkAgentContractAccountId,
      studentOfferItemSettlementItemVoList: offerItem,
      studentInsuranceSubmitSettlementVoList: [], // insurance,
      studentServiceFeeSubmitSettlementVoList: [], // serviceFee,
      studentAccommodationSubmitSettlementVoList: [], // accommodation,
      studentOfferItemCommissionDtoList: item.studentOfferItemCommissionDtoList,
      studentInsuranceCommissionDtoList: [], // item.studentInsuranceCommissionDtoList,
      studentServiceFeeCommissionDtoList: [], // item.studentServiceFeeCommissionDtoList,
      studentAccommodationCommissionDtoList: [], // item.studentAccommodationCommissionDtoList,
    };
  }
}
